import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

import { useDropdown } from '@/hooks';
import clsx from 'clsx';

import Menu from './components/Menu';
import MenuCX from './components/MenuCX';
import ButtonIcon from '../ButtonIcon';
import NotificationIcon from './NotificationIcon';

// import logoSmall from '@/assets/images/logo.png';
import logoSmall from '@/assets/images/synthnode_logo2.png';

import { useIsMobile } from '@/components/UseIsMobile/useIsMobile';

import './styles.scss';

const Navbar = () => {
  const isAuthenticated = !!Cookies.get('token');

  const { isOpen, ref, close, toggle } = useDropdown();
  const isMobile = useIsMobile();

  const navigate = useNavigate();
  const location = useLocation();

  const isCxCenter = location.pathname.startsWith('/cx');

  const handleNotifsClick = () => {
    close();
    navigate('/notifications/all');
  };

  return (
    <nav className={clsx('navbar', isMobile && '-mobile')} ref={ref}>
      <nav className='logo-dropdown-toggle'>
        <Link to={isCxCenter ? '/cx' : '/contact-management'}
          className='logo-link' onClick={close}>
          <img src={logoSmall} />
          <span>Synthnode<sup>TM</sup></span>
        </Link>
        <div className='right'>
          {isAuthenticated && <NotificationIcon onClick={handleNotifsClick} />}
          <ButtonIcon
            icon={isOpen ? 'close' : 'menu'}
            color='deep-sapphire'
            className='dropdown-toggle'
            onClick={toggle}
          />
        </div>
      </nav>
      {isCxCenter ? (
        <MenuCX isOpen={isOpen} close={close} />
      ) : (
        // <Menu isOpen={isOpen} close={close} />
        <MenuCX isOpen={isOpen} close={close} />
      )}
    </nav>
  );
};

export default Navbar;
